import { render } from "./ProfileGroups.vue?vue&type=template&id=109a2a64&scoped=true"
import script from "./ProfileGroups.vue?vue&type=script&lang=ts"
export * from "./ProfileGroups.vue?vue&type=script&lang=ts"

import "./ProfileGroups.vue?vue&type=style&index=0&id=109a2a64&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-109a2a64"

export default script